import {PRODUCT_TYPE_TO_DV_MAPPING} from '@/constants/engine';
import {DomainValueReference} from '@/model/types';

export const mapProductTypeToDomainValue = (productType?: string | null): DomainValueReference | null => {
  if (!productType || !(productType in PRODUCT_TYPE_TO_DV_MAPPING)) return null;

  return {$ref: PRODUCT_TYPE_TO_DV_MAPPING[productType as keyof typeof PRODUCT_TYPE_TO_DV_MAPPING]};
};
